/**
 * The Vehicle Catalog's pages, in the order the section lands on: the first one the viewer can list.
 *
 * One list drives the section gate (`app.routes.ts`), the top navigation entry, the landing redirect
 * and the sidebar's permission batch. A category page lives under its parent list rather than in
 * the sidebar, but is listed here still: a viewer who may list only categories lands on them. A page
 * whose resource is missing here is hidden even from a viewer who may list it, so add a resource in
 * the same change as its page.
 */
export const VEHICLE_CATALOG_SECTIONS = [
  { resource: 'model', path: 'models' },
  { resource: 'trim', path: 'trims' },
  { resource: 'exterior_colour', path: 'exterior-colours' },
  { resource: 'interior_colour', path: 'interior-colours' },
  { resource: 'feature', path: 'features' },
  { resource: 'feature_category', path: 'features/categories' },
  { resource: 'tech-spec', path: 'tech-specs' },
  { resource: 'tech-spec_category', path: 'tech-specs/categories' },
  { resource: 'accessory', path: 'accessories' },
  { resource: 'accessory_category', path: 'accessories/categories' },
  { resource: 'manual', path: 'manuals' },
  { resource: 'manual_group', path: 'manuals/groups' },
  { resource: 'manual_type', path: 'manuals/types' },
] as const;

export const VEHICLE_CATALOG_RESOURCES = VEHICLE_CATALOG_SECTIONS.map((section) => section.resource);
